module.exports = __webpack_public_path__ + "img/jobbliss_auth_img.9a572413.jpg";